import { render, staticRenderFns } from "./bind-phone.vue?vue&type=template&id=231b0021&scoped=true"
import script from "./bind-phone.vue?vue&type=script&lang=js"
export * from "./bind-phone.vue?vue&type=script&lang=js"
import style0 from "./bind-phone.vue?vue&type=style&index=0&id=231b0021&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "231b0021",
  null
  
)

export default component.exports